<div class="contents">  
  <div class="page-header">
    <div class="left-area">
      <span class="title">Auxílios de formações</span>
      <span class="sub-title">Adicione, visualize e edite todos auxílios ormaçãos do sistema</span>
    </div>
  </div>

  <app-search-bar [filters]="[
    { type: 'text', controlName: 'searchText', placeholder: 'Pesquise por uma auxílio de formação' }
  ]" primaryBtnLabel="Adicionar auxílio de formação" (onPrimaryBtnClick)="showDialog()"
    [secondBtnLabel]="'Adicionar Tipo de bolsa'" (onSecondBtnClick)="onSecondBtnClick()"
    (formValueChange)="onFormValueChange($event)"></app-search-bar>

  <div class="list">
    <ng-container *ngIf="isLoading; else content">
      <div class="loading text-center w-full p-3">
        <p>Carregando...</p>
      </div>
    </ng-container>
    <ng-template #content>
      <ng-container *ngIf="bolsas.length > 0; else noData">
        <app-card-bolsa [routerLink]="['detalhe-bolsa', item.id]" *ngFor="let item of bolsas; let i = index"
          [name]="item.tipoBolsa" [avatar]="'/assets/icons/certificate-blue.svg'" [estado]="item.estadoBolsa" [age]="30"
          [country]="'Angola'" [duration]="'6 meses'" [tipoBolsa]="item.tipoBolsa"></app-card-bolsa>
      </ng-container>
      <ng-template #noData>
        <div class="no-data">
          <p>Nenhuma formação disponível no momento.</p>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
<p-toast></p-toast>
